import {http} from './http_service';
import {login} from './http_service';
import {recovery} from './http_service';

export function sanctumCsrfCookie() {
    return login().get('/sanctum/csrf-cookie');
}

export function auth(data) {
    return login().post('/api/auth/login', data);
}

export function changePassword(data) {
    return recovery().post('/auth/change-password', data);
}

export function logout() {
    return http().post('/auth/logout');
}